"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function useOnValueChange(value, onChange) {
  var tracked = react_1.default.useRef(value);
  var oldValue = tracked.current;

  if (value !== oldValue) {
    tracked.current = value;
    onChange(value, oldValue);
  }
}

exports.useOnValueChange = useOnValueChange;